<template>
  <div class="flex text-sm justify-between items-center">
    <div class="flex">
      <div class="flex bg-[#ececf2] rounded-2xl text-[#999] font-bold">
        <div
          class="w-[144px] h-8 leading-8 rounded-2xl text-center cursor-pointer"
          :class="activeBtn === btn.name ? 'bg-black text-white' : ''"
          v-for="(btn, index) in leftBtns"
          :key="index"
          @click="leftClickHandler(btn)"
        >{{btn.label}}</div>
      </div>
      <slot name="left-addon"></slot>
    </div>
    <div class="flex">
      <slot name="right-addon"></slot>
      <div
          class="w-[80px] rounded-2xl h-8 leading-8 text-white font-bold cursor-pointer mr-4"
          :style="{
            backgroundColor: btn.bgColor ? btn.bgColor : 'transparent',
            border: btn.borderColor ? `1px solid ${btn.borderColor}` : 'none',
            color: btn.textColor || '#fff',
            }"
          v-for="(btn, index) in rightBtns"
          :key="index"
          @click="rightClickHandler(btn)"
      >{{btn.label}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    leftBtns:{
      type: Array,
    },
    rightBtns: Array,
  },
  data() {
    return {
      activeBtn:this.leftBtns ? this.leftBtns[0].name : '',
    }
  },
  methods: {
    leftClickHandler(btn) {
      this.activeBtn = btn.name;
      this.$emit('leftClick', btn.name);
    },
    rightClickHandler(btn) {
      this.$emit('rightClick', btn.name);
    }
  }
}
</script>
